// export default () => <div>Error loading page</div>;
import React from 'react'
import { Typography, Button, AppBar, Toolbar } from '@mui/material'

export default class extends React.Component<
  { statusCode?: any },
  { onClient: boolean }
> {
  constructor(props: { statusCode?: any }) {
    super(props)
    this.state = {
      onClient: false,
    }
  }

  componentDidMount() {
    this.setState({
      onClient: true,
    })
  }

  render() {
    // if (this.props.statusCode) {
    //   return <Error statusCode={this.props.statusCode} />;
    // }

    if (!this.state.onClient) {
      return null
    }

    return (
      <div>
        <AppBar style={{ backgroundColor: '#fff' }}>
          <Toolbar />
        </AppBar>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            height: '400px',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            padding: '20px',
          }}
        >
          <div>
            <br />
            <br />
            <br />
            <img
              style={{ width: '70%', maxWidth: '400px' }}
              src="/static/img/page_not_found.svg"
            />

            <Typography
              // style={{ color: "red" }}
              // color="textSecondary"
              gutterBottom={true}
              variant="h6"
            >
              Page does not exist
            </Typography>

            <Typography
              // style={{ color: "red" }}
              // color="textSecondary"
              gutterBottom={true}
              variant="body2"
            >
              either the url page doesn't exist or your connection was
              disconnected
            </Typography>
            <br />
            <Button
              style={{ margin: '5px', maxWidth: '500px' }}
              fullWidth={true}
              onClick={() => {
                location.reload()
                // this.props.reload();
              }}
              color="secondary"
              variant="contained"
            >
              Reload page
            </Button>
            <Button
              href={`${location.protocol}//${location.host}`}
              style={{ margin: '5px', maxWidth: '500px' }}
              color="primary"
              variant={'contained'}
              size={'large'}
              fullWidth={true}
            >
              Go to homepage
            </Button>

            {/* <Button
              href={'https://pledre.com'}
              size="large"
              fullWidth={true}
              color="primary"
              variant={'outlined'}
              style={{ margin: '5px', maxWidth: '500px' }}
            >
              Go to Pledre
            </Button> */}

            <br />
            {/* <img
              style={{
                marginTop: "60px",
                marginBottom: "30px",
                opacity: 0.6
              }}
              width="30%"
              height="auto"
              src="/static/img/asset4.svg"
            /> */}
            <br />
          </div>
        </div>
      </div>
    )
  }
}
